<template>
  <div>
    <b-tooltip
      :label="$t('sondage.exporter')"
      position="is-left"
    >
      <img
        @click="exportExcelPdf()"
        src="@/assets/img/icons/export-icon.png"
        style="width:16px;margin-right:10px;cursor:pointer; margin-bottom:2px;"
        alt="icon-export"
    />
    </b-tooltip>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ButtonExport',
  computed: {
    ...mapGetters(['modalExportExcelPdf', 'sondage'])
  },
  methods: {
    sendMessageToParent (taskToDo) {
      let message = {
        task: taskToDo
      }
      window.top.postMessage(message, '*')
    },
    exportExcelPdf () {
      //this.$store.commit('UNLOAD_RESULTATS')
      this.sendMessageToParent('scrollToTop')
      this.$store.commit('MODAL_EXPORTEXCELPDF', {
        sondageId: this.sondage.id,
        cardList: false,
        cardIndex: null,
        sondageUrlModerateur: this.sondage.urlParticipant,
        activeModalExportExcelPdf: true
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/resultats/components/ButtonExport.vue